import z from "zod";

const ImageObjectSchema = z.object({
  id: z.string().min(1, "Missing image ID"),
  url: z.string().url("Invalid image URL"),
  alt: z.string().optional(),
});

export const ImageArraySchema = z.array(ImageObjectSchema);